import { SET_HTTP_ERROR_SETTING } from "../constant/errorHandlerConstant";

export function setHTTPError(error) {
  return {
    type: SET_HTTP_ERROR_SETTING,
    payload: error,
  };
}